import { HTTP } from '../../utils/http';
import { PaginationParams } from '../../utils/pagination-params';

export const SchoolCampService = {
    createCamp(schoolId, form) {
        return HTTP.post(`/schools/${schoolId}/camps`, form);
    },

    getCamps(schoolId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`no-auth/schools/${schoolId}/camps`);
        return HTTP.get(url, { cache: false });
    },

    getCampsByInstructor(schoolId, instructorId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/camps/instructor/${instructorId}`);
        return HTTP.get(url, { cache: false });
    },

    getCampsGeneralInfo(schoolId) {
        return HTTP.get(`/schools/${schoolId}/camps/statistics`);
    },

    getCampStatistics(schoolId, campPricingId) {
        return HTTP.get(`/schools/${schoolId}/camp-pricing/${campPricingId}/rosters/statistics`);
    },

    getCamp(schoolId, campId) {
        return HTTP.get(`/schools/${schoolId}/camps/${campId}`, { cache: false });
    },

    editCamp(schoolId, campId, form) {
        return HTTP.put(`/schools/${schoolId}/camps/${campId}`, form);
    },

    deleteCamp(schoolId, campId) {
        return HTTP.delete(`/schools/${schoolId}/camps/${campId}`);
    },

    deleteMultipleCamps(schoolId, campIds) {
        return HTTP.delete(`/schools/${schoolId}/camps?ids=${campIds}`);
    },

    bulkUpdateCamps(schoolId, campIds, form) {
        const body = {
            ids: campIds,
            ...form
        };
        return HTTP.patch(`/schools/${schoolId}/camps`, body);
    },

    getCampsByDate(schoolId, date, timezone) {
        return HTTP.get(`/schools/${schoolId}/camps/dashboard?filterDate=${date}&timeZone=${timezone}`);
    },

    updateCampSettings(schoolId, settingsForm) {
        return HTTP.put(`/schools/${schoolId}/parent-portal-settings/camps`, settingsForm);
    },

    getCampSettings(schoolId) {
        return HTTP.get(`/schools/${schoolId}/parent-portal-settings/camps`);
    },

    getCampPricingName(schoolId, campPricingId) {
        return HTTP.get(`/schools/${schoolId}/camp-pricings/${campPricingId}/name`);
    },

    getCampAddOns(schoolId, campPricingId) {
        return HTTP.get(`/schools/${schoolId}/camp-pricing/${campPricingId}/addons`);
    },

    getCopyLinkCamp(schoolId, campId) {
        return HTTP.get(`/schools/${schoolId}/camps/${campId}/copy-link`);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/pages/camp.service.js